export default __webpack_public_path__ + "static/media/Desconto50.bdd88b4c.png";